import React from "react";
import "../styles/Home.css";
import cookieImg from "../assets/privacy.png";

export default function CookiePolicy() {
  const openPreferences = () => {
    if (typeof window !== "undefined" && window.openCookiePreferences) {
      window.openCookiePreferences();
    }
  };

  return (
    <div>
      <section
        className="privacy-wrapper"
        style={{ marginLeft: "32px", marginRight: "32px" }}
      >
        <div className="privacy-container">
          <div className="privacy-text">
            <h2 style={{ fontSize: "2.5rem", color: "#39512f" }}>
              Cookie Policy
            </h2>
          </div>
        </div>

        <div className="privacy-container">
          <div className="privacy-text">
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              Alfa SouthIn Cafe operates the website alfasouthcafe.com. This
              Cookie Policy explains what cookies are, how and why we use them,
              and the choices you have. By using our site you can accept, reject
              or customize the cookies we set through the banner shown on your
              first visit — and you can change your mind at any time.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              What Are Cookies?
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              Cookies are small text files stored on your browser when you visit
              a website. They help the site remember your actions and
              preferences (such as login, language and region) over time, and
              allow us to understand how the site is used so we can keep
              improving it.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Personalization (Functional &amp; Essential) Cookies
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              These are always active because the site cannot work properly
              without them. They manage your session and remember your choices —
              keeping you signed in to your account for extended periods (e.g.
              30 days) unless you log out, and automatically loading your
              preferred language, region or interface features so you don't have
              to re-enter them on every visit.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Analytics (Performance) Cookies
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              With your consent we connect the site to an analytics platform
              (such as Google Analytics) to count total visits, see where our
              traffic comes from, and observe how visitors move around the site.
              This aggregated data helps us identify our most and least popular
              pages so we can continuously measure and improve the site's
              performance and layout.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Marketing (Targeting &amp; Social) Cookies
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              With your consent we deploy tracking pixels (such as the Meta
              Pixel), managed through a tag manager like Google Tag Manager, to
              measure exact customer actions after an ad click — such as viewing
              our menu, booking a reservation or completing an order. Our
              advertising partners use these cookies to build audience profiles,
              serve you relevant retargeting ads on other websites and social
              platforms, and control how often you see the same ad. Social media
              cookies also let you share our content and may track you across
              other sites to influence what you see elsewhere.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Simplified Forms (Convenience) Cookies
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              With your consent we store basic first-party details (such as your
              name or email) locally on your device to securely pre-fill forms,
              reducing friction during reservations, sign-ups and enquiries. As
              third-party cookies are phased out across the web, this
              first-party data — collected directly from you — helps us keep
              personalizing your experience in a privacy-compliant way.
            </p>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Managing Your Preferences
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              You are in control. Essential cookies are always on, but you can
              enable or disable analytics, marketing and convenience cookies at
              any time. Use the button below to reopen the Privacy Preference
              Center, or adjust cookie settings in your browser. Blocking some
              cookies may affect how parts of the site work.
            </p>
            <button
              type="button"
              className="cookie-manage-btn"
              onClick={openPreferences}
            >
              Manage Cookie Preferences
            </button>

            <h4 style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}>
              Contact Us
            </h4>
            <p style={{ fontSize: "14px", color: "#3e3a35" }}>
              If you have any questions about this Cookie Policy, please contact
              us at Call / Whatsapp: 077220 06638, Email: alfasouthin@gmail.com.
              This Cookie Policy was last updated on [09/July/2026].
            </p>
          </div>

          <div className="privacy-side">
            <div className="info-box">
              <div className="info1">
                <span className="info-icon">🍪</span>
              </div>
              <div>
                <p style={{ fontSize: "19px", color: "#0d1013" }}>
                  Your Consent, Your Choice
                </p>
                <p style={{ fontSize: "14px", color: "#0d1013" }}>
                  On your first visit you can Accept All, Reject Optional, or
                  Manage Preferences to choose exactly which cookie categories
                  we may use. Your choice is remembered on your device and only
                  the trackers you allow are ever loaded.
                </p>
              </div>
            </div>

            <img src={cookieImg} alt="Cookie Policy" className="privacy-img" />

            <div className="privacy-footer">
              <h5
                style={{ fontSize: "16px", color: "#3e3a35", fontWeight: 600 }}
              >
                Changes to This Cookie Policy
              </h5>
              <p style={{ fontSize: "14px", color: "#3e3a35" }}>
                alfasouthcafe.com has the discretion to update this Cookie
                Policy at any time. We encourage users to check this page
                regularly for any changes to stay informed.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
